import { render, staticRenderFns } from "./Backbutton.vue?vue&type=template&id=18c9ddf6&scoped=true&"
import script from "./Backbutton.vue?vue&type=script&lang=js&"
export * from "./Backbutton.vue?vue&type=script&lang=js&"
import style0 from "./Backbutton.vue?vue&type=style&index=0&id=18c9ddf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9ddf6",
  null
  
)

export default component.exports